/**
 * Lead prioritization data for a person.
 * Source: GET /api/persons/:person_id/lead_prioritization
 * Update: PUT /api/lead_prioritizations/:id
 */
export type LeadResponse =
  | "interested"
  | "not_interested"
  | "monthly_rent_expensive"
  | "not_has_downpayment"
  | "pending";

export interface LeadPrioritization {
  id: number;
  person_id: number;
  priority_label: string | null;
  prioritized: boolean;
  lead_response: LeadResponse | null;
}

export interface LeadResponseOption {
  readonly value: LeadResponse;
  readonly label: string;
}

export const LEAD_RESPONSE_OPTIONS: readonly LeadResponseOption[] = [
  { value: "pending", label: "Por contactar" },
  { value: "interested", label: "Interesado" },
  { value: "monthly_rent_expensive", label: "Renta mensual costosa" },
  { value: "not_has_downpayment", label: "Sin enganche disponible" },
  { value: "not_interested", label: "Otro (No interesado)" },
];
